import type { CommonCopy } from "../types";

export const COMMON_PT_BR: CommonCopy = {
  skipLink: "Pular para o conteúdo",
  header: {
    nav: [
      { href: "/apps", label: "Apps" },
      { href: "/business", label: "Para sua empresa" },
      { href: "/developers", label: "Para desenvolvedores" },
      { href: "/blog/", label: "Blog" },
    ],
    cta: { href: "/business#contato", label: "Fale Conosco" },
    openMenu: "Abrir menu",
    closeMenu: "Fechar menu",
  },
  contactForm: {
    title: "Entre em Contato",
    subtitle:
      "Tem uma ideia? Quer conhecer mais sobre nossos apps? Fale conosco!",
    name: "Nome Completo",
    namePlaceholder: "Seu nome",
    email: "E-mail",
    emailPlaceholder: "seu@email.com",
    company: "Empresa (opcional)",
    companyPlaceholder: "Nome da empresa",
    message: "Mensagem",
    messagePlaceholder: "Conte-nos sobre seu interesse...",
    submit: "Enviar Mensagem",
    submitting: "Enviando...",
    turnstileMissing: "Por favor, complete a verificação de segurança.",
    success: "Mensagem enviada com sucesso! Entraremos em contato em breve.",
    failure: "Erro ao enviar mensagem. Por favor, tente novamente.",
  },
  waitlistForm: {
    email: "E-mail",
    emailPlaceholder: "seu@email.com",
    name: "Nome (opcional)",
    company: "Empresa (opcional)",
    role: "Cargo (opcional)",
    consentBefore:
      "Quero ser avisado(a) quando estiver disponível e concordo com a ",
    consentLink: "Política de Privacidade",
    consentAfter:
      ", inclusive com o armazenamento dos meus dados em fornecedores no exterior.",
    submit: "Entrar na lista de espera",
    submitting: "Enviando...",
    success:
      "Pronto! Você está na lista e vai receber um aviso quando abrirmos.",
    closed: "A lista de espera ainda não abriu.",
    contactInstead: "Fale conosco",
    errors: {
      email: "Informe um e-mail válido.",
      consent: "Marque a caixa de consentimento para continuar.",
      tooLong: "Um dos campos está longo demais. Abrevie e tente de novo.",
      turnstile: "Complete a verificação de segurança e tente de novo.",
      unavailable: "Lista de espera indisponível no momento. Tente mais tarde.",
      generic: "Não foi possível enviar. Tente novamente.",
    },
  },
  footer: {
    tagline: "Transformando ideias em soluções digitais conscientes.",
    sections: {
      quickLinks: "Links Rápidos",
      developers: "Desenvolvedores",
      institutional: "Institucional",
      contact: "Contato",
    },
    links: {
      apps: "Apps",
      business: "Para sua empresa",
      services: "Serviços",
      blog: "Blog",
      developers: "Para desenvolvedores",
      bootgly: "Bootgly",
      bootglyDocs: "Documentação do Bootgly",
      dataruni: "Dataruni",
      terms: "Termos de Uso",
      privacy: "Política de Privacidade",
      cookies: "Política de Cookies",
    },
    rights: "Todos os direitos reservados.",
    madeWith: "Feito com ❤️ por Codecious",
    social: {
      linkedin: "LinkedIn da Codecious",
      instagram: "Instagram da Codecious",
      facebook: "Facebook da Codecious",
    },
  },
  notFound: {
    heading: "Página não encontrada",
    message: "Desculpe, a página que você procura não existe.",
    detail: "Ela pode ter sido movida ou removida.",
    goHome: "Voltar ao início",
  },
  errorBoundary: {
    heading: "Ocorreu um erro inesperado.",
    details: "Detalhes técnicos",
    reload: "Recarregar página",
  },
};
